<template>
  <div class="order-records-view">
    <StandardSearchPageView
      ref="table"
      rowKey="orderNo"
      :colNum="4"
      :labelColSpan="8"
      :wrapperColSpan="16"
      :columns="columns"
      :queryParams="queryParams"
      :searchOptions="searchOptions"
      :requestPromise="loadDataList"
    >
      <template v-slot:rateplanNameSlot="{ text }">
        <ellipsis :length="30" tooltip>{{ text }}</ellipsis>
      </template>
    </StandardSearchPageView>
  </div>
</template>

<script>
import StandardSearchPageView from '@/customComponents/standard/StandardSearchPageView.vue'

export default {
  name: 'OrderRecordsComponent',
  components: {
    StandardSearchPageView
  },
  data() {
    return {
      queryParams: {},
      searchOptions: [
        {
          name: '订单编号',
          key: 'orderNo',
          type: 'input',
          placeholder: '请输入订单编号'
        },
        {
          name: '产品名称',
          key: 'productName',
          type: 'input',
          placeholder: '请输入产品名称'
        },
        {
          name: '大横琴订单号',
          key: 'dhqOrderNo',
          type: 'input',
          placeholder: '请输入大横琴订单号'
        }
      ],
      columns: [
        {
          title: '订单编号',
          dataIndex: 'orderNo',
          width: '180px'
        },
        {
          title: '大横琴订单号',
          dataIndex: 'dhqOrderNo',
          width: '160px'
        },
        {
          title: '大横琴价格计划名称',
          dataIndex: 'rateplanName',
          width: '280px',
          scopedSlots: { customRender: 'rateplanNameSlot' }
        },
        {
          title: '产品名称',
          dataIndex: 'productName',
          width: '400px',
          ellipsis: true
        },
        {
          title: '订单状态',
          dataIndex: 'stateName',
          width: '120px'
        },
        {
          title: '来源',
          dataIndex: 'sourceName',
          width: '120px'
        },
        {
          title: '下单时间',
          dataIndex: 'createTime',
          width: '180px'
        }
      ]
    }
  },
  methods: {
    buildListParams(params = {}) {
      const { limitDto = {}, orderNo, dhqOrderNo, productName } = params
      const requestParams = {
        merchantId: this.$store.getters.userInfo.merchantId,
        pageNum: limitDto.pageNum || 1,
        pageSize: limitDto.pageSize || 10
      }
      if (orderNo) requestParams.orderNo = orderNo
      if (dhqOrderNo) requestParams.dhqOrderNo = dhqOrderNo
      if (productName) requestParams.productName = productName
      return requestParams
    },
    loadDataList(params) {
      return this.getHttpServices().getSourceService()
        .post('dahengqin/platform/order_list', this.buildListParams(params))
        .then(res => ({
          data: res.data,
          totalCount: res.totalCount,
          pageCount: res.pageCount
        }))
    }
  }
}
</script>

<style scoped>
.order-records-view {
  display: flex;
  flex-direction: column;
  flex: 1;
  width: 100%;
}
</style>
